import { render, staticRenderFns } from "./GolTipster.vue?vue&type=template&id=2c678b62&scoped=true&"
import script from "./GolTipster.vue?vue&type=script&lang=js&"
export * from "./GolTipster.vue?vue&type=script&lang=js&"
import style0 from "./GolTipster.vue?vue&type=style&index=0&id=2c678b62&prod&lang=css&"
import style1 from "./GolTipster.vue?vue&type=style&index=1&id=2c678b62&prod&scoped=true&lang=scss&"
import style2 from "./GolTipster.vue?vue&type=style&index=2&id=2c678b62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c678b62",
  null
  
)

export default component.exports